import React, { useState } from "react";
import { Storage } from "@aws-amplify/storage";
import { API, Auth } from 'aws-amplify';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Link } from 'react-router-dom';
import Dropzone from 'react-dropzone';
import "./file.css";
import Alert from 'react-bootstrap/Alert';
import { FileEarmarkArrowUp } from 'react-bootstrap-icons';
import Spinner from 'react-bootstrap/Spinner';

const UploadFileeDiscovery = (props) => {
  const projectId = props.project_id
  const [fileNames, setFileNames] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [uploadMessage, setUploadMessage] = useState('');
  const [isBusy, setIsBusy] = useState(false);

  const handleDrop = async(acceptedFiles) => {
    setErrorMessage('');
    setUploadMessage('');

    const user = await Auth.currentAuthenticatedUser()
    const token = user.signInUserSession.idToken.jwtToken
    const requestInfo = { headers: { Authorization: token } }

    API.get("DocumentSearchUser", `/getuserinfo`, requestInfo)
      .then(response => {
        let numberOfFiles = response.user_files
        let userAccountType = response.user_account_type
        if (userAccountType=='free' && numberOfFiles >= 10) {
          setErrorMessage('You have reached the maximum number of uploaded files!');
          return;
        }
        else {
          acceptedFiles.forEach(async element => {
            let x = props.entities.find(o => o.file_name == element.name);
            if (x != undefined) {
              setErrorMessage('A file with the same name already exsists in the project.');
              return;
            }
            setIsBusy(true);
            console.log(projectId);
            const user = await Auth.currentAuthenticatedUser();
            const result = await Storage.put(`files/${projectId}/${element.name}`,
              element,
              { level: "private", contentType: element.type })
              .then(result => {
                setIsBusy(false);
                setUploadMessage("Success uploading file!");
                props.onUpload();
              })
              .catch(err => {
                setIsBusy(false);
                console.log('error in upload', err)
                setErrorMessage('Cannot upload the file:' + err);
              });
          });
        }
      })
  };

  return (
    <>
      <Row>
        <Col>
          <br />
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/ediscovery" }}>eDiscovery</Breadcrumb.Item>
            <Breadcrumb.Item active>{projectId}</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <Row>
        <Col>
          <div style={{ textAlign: 'center' }}>
            <h1 className="center">Project Document List</h1>
            <h3>Load new documents or Use existing documents
            </h3>
          </div>
        </Col>
      </Row>
      <Row>

        <Col>
          <Dropzone onDrop={handleDrop}>
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps({ className: "dropzone" })}>
                <input {...getInputProps()} />
                <span><FileEarmarkArrowUp className="upload-icon" /> Drag & Drop files, or click to select files</span>
              </div>
            )}
          </Dropzone>
          {errorMessage && (
            <Alert key="danger" variant="danger">
              {errorMessage}
            </Alert>
          )}
          {uploadMessage && (
            <Alert key="primary" variant="primary">
              {uploadMessage}
            </Alert>
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          {isBusy &&
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          }
        </Col>
      </Row>
    </>
  );
}
export default UploadFileeDiscovery;